import $ from 'jquery'
import { exists } from './helpers'

export const Curtain = {
  init: function () {
    if (!exists('#curtain')) {
      $('body').append(
        '<div id="curtain" class="hidden"><div class="curtain-target js-close-popup"></div></div>'
      )
    }
  },

  show: function () {
    $('#curtain').showMe()
  },

  hide: function () {
    $('#curtain').hideMe()
  },
}

$(Curtain.init)
